import React, { useState, useEffect } from "react";
import "./NetworkButtonModal.scss";
import Modal from "react-modal";
import { useSelector, useDispatch } from "react-redux";
import NetworkModalFirstPage from "./NetworkModalPages/NetworkModalFirstPage";
import NetworkModalSecondPage from "./NetworkModalPages/NetworkModalSecondPage";
import { sendInvitation } from "./actions/action_sendInvitation";
import { fetchUserData } from "../../global/app/actions/actions_fetchUsers";
import { FaPlus } from "react-icons/fa";
import { MdClose } from "react-icons/md";

function NetworkButtonModal() {
  const [submit, setSubmit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [recipientEmail, setRecipientEmail] = useState(null);
  const currentUser = useSelector(
    (state) => state.appReducer.userDataReducer.data
  );
  const error = useSelector((state) => state.networkInvitationReducer.error);
  const dispatch = useDispatch();

  const openModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // when last page refetch user data to get list of invitations
  const closeModal = () => {
    setShowModal(false);
    setPage(1);
    setSubmit(false);
    dispatch(fetchUserData());
  };

  const onChange = (e) => {
    if (e?.target) {
      setRecipientEmail(e.target.value);
    }
  };
  const onSubmit = () => {
    setSubmit(true);
  };

  useEffect(() => {
    let timeout;
    if (submit) {
      dispatch(sendInvitation(recipientEmail));
      timeout = setTimeout(() => {
        setPage(2);
      }, 2000);
    }

    return () => clearTimeout(timeout);
  }, [submit]);

  const previousPage = () => {
    setPage(page - 1);
    setSubmit(false);
  };

  return (
    <div>
      <button onClick={openModal} className="usa-button modal-button">
        <FaPlus className="plus-icon" />{" "}
        <span className="button-text">Member</span>
      </button>

      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        className="network-modal"
        overlayClassName="Overlay"
      >
        <button
          className="modal-exit-x"
          onClick={handleCloseModal}
          type="button"
        >
          <MdClose className="close-icon" />
        </button>
        {page === 1 && (
          <NetworkModalFirstPage
            onSubmit={onSubmit}
            onChange={onChange}
            currentUser={currentUser}
            isSubmitting={submit}
          />
        )}
        {page === 2 && (
          <NetworkModalSecondPage
            previousPage={previousPage}
            closeModal={closeModal}
            currentUser={currentUser}
            recipientEmail={recipientEmail}
            error={error}
          />
        )}
      </Modal>
    </div>
  );
}

export default NetworkButtonModal;
